import styled from 'styled-components';

import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';
import { FontWeight, getFontWeightByName } from '@r1-frontend/ui-kit/themes/typography.fontWeight';

import { getFontSize } from './helpers/getFontSize';

type THeaderProps = {
    /**
     * Насыщенность (толщина) шрифта
     *
     * @default none
     */
    $weight?: FontWeight,
}

const BaseHeader = styled.h1`
    margin: 0;
    padding: 0;
    color: ${({ theme }: ThemedProperties) => theme.colors.text.head};
    font-weight: ${({ $weight = 'bold' }: ThemedProperties<THeaderProps>) => getFontWeightByName($weight)};
`;

/**
 * Заголовок страницы / баннерный текст
 */
export const H1 = styled(BaseHeader)<THeaderProps>`
    ${getFontSize(1)};
`;

/**
 * Заголовок блоков или разделов, страницы при большом количестве текста
 */
export const H2 = styled(BaseHeader.withComponent('h2'))<THeaderProps>`
    ${getFontSize(2)};
`;

/**
 * Заголовок карточки или виджета
 */
export const H3 = styled(BaseHeader.withComponent('h3'))<THeaderProps>`
    ${getFontSize(3)};
`;

/**
 * Заголовок текстового блока
 */
export const H4 = styled(BaseHeader.withComponent('h4'))<THeaderProps>`
    ${getFontSize(4)};
`;

/**
 * Заголовок текстового блока или выделение части текста
 */
export const H5 = styled(BaseHeader.withComponent('h5'))<THeaderProps>`
    ${getFontSize(5)};
`;

/**
 * Заголовок текстового блока или выделение части текста
 */
export const H6 = styled(BaseHeader.withComponent('h6'))<THeaderProps>`
    ${getFontSize(6)};
`;
